/**
 * FaaTrackingTile.mask.ts
 *
 * Data-masking logic for FaaTrackingTile.
 * When showData is false, formatted values are replaced with "--"
 * so no real performance data is visible.
 */

import type { FaaTrackingResponse } from "../../../../../services/AnnualIncomeDashboard/annualIncomeDashboardAPI.types";

const MASKED_VALUE = "--";

export const maskFaaTrackingData = (data: FaaTrackingResponse, showData: boolean): FaaTrackingResponse => {
  if (showData) return data;

  return {
    ...data,
    faaTracking: {
      ...data.faaTracking,
      foundersPlatinumLegs: {
        ...data.faaTracking.foundersPlatinumLegs,
        formatted: MASKED_VALUE,
        moMTrend: undefined,
      },
      faaPoints: { ...data.faaTracking.faaPoints, formatted: MASKED_VALUE, moMTrend: undefined },
      faaMultiplier: { ...data.faaTracking.faaMultiplier, formatted: MASKED_VALUE },
      superLegs: { ...data.faaTracking.superLegs, formatted: MASKED_VALUE },
    },
  };
};
